export default __webpack_public_path__ + "static/media/money.81e3e407.jpg";